<template>
    <div class="article-music-description">
        <p>One of the things we love about West Coast Swing is that you can dance it to pretty much any music.</p>
        <p>We're always finding new music for our classes so we thought we'd share some with you.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleMusicDescription',
};
</script>
